import Pusher, { Channel, Pusher as PusherType } from 'pusher-js';
import { Dispatch } from 'redux';
import { EmployerEvent, RecruiterEvent } from '../types/pusher';
import { Notification } from '../types/notifications';
import { UserRoleType, UserState } from '../types/global';
import { pusherEvent } from '../actions/pusher';

export const getChannelName = (user: UserState) => {
  return `private-${user.role}-${user.id}`;
};

export const configure = (user: UserState) => {
  if (!user.token) {
    return null;
  }

  const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY as string, {
    authEndpoint: `${process.env.REACT_APP_BASE_URL}/pusher/auth`,
    authTransport: 'ajax',
    auth: {
      headers: {
        Authorization: user.token,
      },
    },
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    encrypted: true,
  });

  return pusher;
};

export const bindRoleEvents = (
  events: (EmployerEvent | RecruiterEvent)[],
  channel: Channel,
  dispatch: Dispatch
) => {
  events.forEach((event: EmployerEvent | RecruiterEvent) => {
    channel.bind(event, (data: Notification) => {
      dispatch(pusherEvent({ event, data }));
    });
  });
};

export const bindEvents = (role: UserRoleType, channel: Channel, dispatch: Dispatch) => {
  switch (role) {
    case 'EMPLOYER':
      return bindRoleEvents(Object.keys(EmployerEvent) as EmployerEvent[], channel, dispatch);
    case 'RECRUITER':
      return bindRoleEvents(Object.keys(RecruiterEvent) as RecruiterEvent[], channel, dispatch);
    default:
      return null;
  }
};

export const subscribe = (pusher: PusherType | null, user: UserState, dispatch: Dispatch) => {
  if (user.id === null || user.id === undefined || !pusher) {
    return null;
  }

  if (process.env.NODE_ENV !== 'production') {
    Pusher.logToConsole = true;
  }

  const channelName = getChannelName(user);
  const channel = pusher.subscribe(channelName);
  bindEvents(user.role as UserRoleType, channel, dispatch);

  return channelName;
};

export const unsubscribe = (pusher: PusherType | null, channelName: string | null) => {
  if (channelName && pusher) {
    pusher.unsubscribe(channelName);
  }
};
